import { translate } from '../i18n/i18n';
import { api } from '../api/client';

export type TermsStatus = {
  /** The wording in force, as the server sees it. */
  currentVersion: string;
  /** What this account last agreed to, or null if it never has. */
  acceptedVersion: string | null;
  acceptedAtEpochMs: number | null;
  upToDate: boolean;
};

export async function fetchTermsStatus(): Promise<TermsStatus> {
  return api<TermsStatus>('/me/terms', { token: true });
}

export async function acceptTerms(version: string): Promise<TermsStatus> {
  return api<TermsStatus>('/me/terms', { method: 'POST', token: true, body: { version } });
}

export function describeAccepted(status: TermsStatus | null): string {
  if (!status || !status.acceptedAtEpochMs) return translate('Not agreed to yet on this account.');
  const when = new Date(status.acceptedAtEpochMs).toLocaleDateString(undefined, {
    day: 'numeric', month: 'long', year: 'numeric',
  });
  return translate('Agreed to on {when}, version {version}.', { when, version: status.acceptedVersion ?? '' });
}
